import myAPI from '../resources'
import config, { carbuyservice } from '../../config'
import carbuyserviceAPI from '../clients/carBuyService'

const carBuyUrl = config.carbuyservice;

export default {
    login: (creds) => {
        return myAPI.post(`${carbuyservice}/LiveVox/Login`, creds, {
        }).then(resp =>{
            return resp;
        }).catch((err) => { 
            return {status: err.response.status}
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/clients/livevoxService.js